<template>
  <div class="content">
    <div class="container-fluid">
      <!-- Add navigation tabs -->
      <ul class="nav nav-tabs mb-3">
        <li class="nav-item">
          <a class="nav-link pointer text-secondary" :class="{ active: activeTab === 'generalSettings' }"
            @click="activeTab = 'generalSettings'">
            Genel Sistem Ayarları
          </a>
        </li>
        <li class="nav-item">
          <a class="nav-link pointer text-secondary" :class="{ active: activeTab === 'mailSettings' }"
            @click="activeTab = 'mailSettings'">
            Mail Gönderim Zamanlama Ayarları
          </a>
        </li>
        <li class="nav-item">
          <a class="nav-link pointer text-secondary" :class="{ active: activeTab === 'mailTemplates' }"
            @click="activeTab = 'mailTemplates'">
            Mail Tema Ayarları
          </a>
        </li>
      </ul>

      <!-- General Settings Edit Form -->
      <div class="row" v-show="activeTab === 'generalSettings'">
        <div class="col-12">
          <card class="strpied-tabled-with-hover mb-3 pb-3" body-classes="table-full-width table-responsive">
            <template slot="header">
              <h4 class="card-title m-1">Genel Sistem Ayarları</h4>

              <p class="card-category m-1">Şirketinize ait genel sistem ayarlarını düzenleyin. </p>

              <div class="row mt-3">
                <div class="col-md-4">
                  <base-input type="text" label="Şirket Adı" v-model="config.companyName.value">
                  </base-input>
                </div>
                <div class="col-md-4">
                  <base-input type="text" :disabled="config.companyIdentifier.isLocked" label="Şirket Kimlik Numarası"
                    v-model="config.companyIdentifier.value">
                  </base-input>
                </div>
                <div class="col-md-4">
                  <base-input type="text" label="Şirket Website Adresi" v-model="config.companyWebsite.value">
                  </base-input>
                </div>
              </div>

              <div class="row mt-3">
                <div class="col-md-4">
                  <base-input type="text" label="Şirket İletişim Kişisi" v-model="config.companyContactPerson.value">
                  </base-input>
                </div>
                <div class="col-md-4">
                  <base-input type="tel" label="Şirket İletişim Numarası" v-model="config.companyPhone.value">
                  </base-input>
                </div>
                <div class="col-md-4">
                  <base-input type="email" label="Şirket Email Adresi" v-model="config.companyEmail.value">
                  </base-input>
                </div>
              </div>

              <div class="row mt-3">
                <div class="col-md-12">
                  <textarea class="form-control" rows="5" label="Şirket Adresi" placeholder="Şirket adresi giriniz"
                    v-model="config.companyAddress.value">
                  </textarea>
                </div>
              </div>

              <div class="row mt-3">
                <div class="col-md-4">
                  <label>Portföy Platformu</label>
                  <select class="form-control" v-model="config.portfolioPlatform.value">
                    <option v-for="platform in Object.entries(config.portfolioPlatformSelections.value)"
                      :key="platform[0]" :value="platform[0]">
                      {{ platform[1] }}
                    </option>
                  </select>
                </div>

                <div v-if="config.portfolioPlatform.value !== 'none'" class="col-md-6">
                  <base-input type="website" label="Portfolio Adresi" v-model="config.portfolioPlatformTarget.value"
                    :disabled="config.portfolioPlatformTarget.isLocked === true">
                  </base-input>
                </div>



              </div>


              <div class="row mt-3 float-right">
                <div class="col-md-12 text-center">
                  <button type="submit" class="btn btn-primary btn-fill font-weight-bold"
                    @click.prevent="saveGeneralSettingsConfig">
                    Kaydet
                  </button>
                </div>
              </div>




            </template>
          </card>

        </div>
      </div>

      <!-- Mail Settings Edit Form -->
      <div class="row" v-show="activeTab === 'mailSettings'">
        <div class="col-12">
          <card class="strpied-tabled-with-hover" body-classes="table-full-width table-responsive">
            <template slot="header">
              <h4 class="card-title m-1">Mail Gönderme Ayarları</h4>
              <p class="card-category m-1">Mail gönderme ayarlarını düzenleyin. Mailin Gönderilecek günlerini, saatlerini
                ayarlayın. Mail gönderme sistemini durdurun veya başlatın. </p>

              <div class="row mt-3">
                <div class="col-md-4">
                  <label>Mail Gönderim Botu Aktif mi?</label>

                </div>
                <div class="col-md-8">
                  <base-checkbox type="text" label="Aktif" placeholder="Aktif" v-model="config.isMailSendRunning.value"
                    :checked="config.isMailSendRunning.value"
                    @click="config.isMailSendRunning.value = !config.isMailSendRunning.value">
                  </base-checkbox>
                </div>
              </div>
              <div class="row">
                <div class="col-md-12">
                  <div class="row mt-3">
                    <div class="col-md-4">
                      <label>Dakikada Gönderilecek Mail Sayısı</label>
                    </div>
                    <div class="col-md-2">
                      <base-input type="number" max="100" min="1" oninput="if(this.value > 100) this.value = 100"
                        placeholder="Dakikada gönderilecek mail sayısı" v-model="config.perMinutesSendMail.value">
                      </base-input>
                    </div>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-md-12">
                  <div class="row mt-3">
                    <div class="col-md-4">
                      <label>Sistem Zaman Dilimi</label>
                    </div>
                    <div class="col-md-5">
                      <select class="form-control" v-model="config.systemTimeZone.value">
                        <option v-for="(zone, index) in [
                          { value: 'America/New_York', label: 'New York (UTC-5)' },
                          { value: 'Europe/London', label: 'Londra (UTC+0)' },
                          { value: 'Europe/Amsterdam', label: 'Amsterdam (UTC+1)' },
                          { value: 'Europe/Berlin', label: 'Berlin (UTC+1)' },
                          { value: 'Europe/Brussels', label: 'Brüksel (UTC+1)' },
                          { value: 'Europe/Budapest', label: 'Budapeşte (UTC+1)' },
                          { value: 'Europe/Copenhagen', label: 'Kopenhag (UTC+1)' },
                          { value: 'Europe/Madrid', label: 'Madrid (UTC+1)' },
                          { value: 'Europe/Oslo', label: 'Oslo (UTC+1)' },
                          { value: 'Europe/Paris', label: 'Paris (UTC+1)' },
                          { value: 'Europe/Prague', label: 'Prag (UTC+1)' },
                          { value: 'Europe/Rome', label: 'Roma (UTC+1)' },
                          { value: 'Europe/Stockholm', label: 'Stockholm (UTC+1)' },
                          { value: 'Europe/Vienna', label: 'Viyana (UTC+1)' },
                          { value: 'Europe/Warsaw', label: 'Varşova (UTC+1)' },
                          { value: 'Europe/Istanbul', label: 'Türkiye (UTC+3)' },
                          { value: 'Europe/Moscow', label: 'Moskova (UTC+3)' },
                          { value: 'Asia/Dubai', label: 'Dubai (UTC+4)' },
                          { value: 'Asia/Shanghai', label: 'Şangay (UTC+8)' }
                        ]" :key="index" :value="zone.value">
                          {{ zone.label }} - {{ new Date().toLocaleTimeString('en-US', { timeZone: zone.value }) }}
                        </option>
                      </select>
                    </div>
                  </div>
                </div>
              </div>

              <h4 class="mt-3">Mail Gönderim Zaman Aralıkları</h4>
              <label>Hangi gün, hangi saatler arası mail gönderilsin?</label>

              <div class="row">
                <div class="col-md-8">
                  <label>Saatlik Maksimum Mail Sayısı</label>
                </div>
                <div class="col-md-2">
                  <badge class="badge badge-secondary m-1 p-2">{{ config.perMinutesSendMail.value * 60 }}</badge>
                </div>
              </div>
              <div class="row">
                <div class="col-md-8">
                  <label>Gönderim Aralığına Göre Haftalık Maksimum Mail Sayısı</label>
                </div>
                <div class="col-md-2">
                  <badge class="badge badge-secondary m-1 p-2">{{ calculateMaxMailWeekly() }}</badge>
                </div>
              </div>

              <card class="strpied-tabled-with-hover mt-3" body-classes="table-full-width table-responsive">
                <div class="row mb-3"
                  v-for="(day, index) in ['Pazartesi', 'Salı', 'Çarşamba', 'Perşembe', 'Cuma', 'Cumartesi', 'Pazar']"
                  :key="index">
                  <div class="col-md-2 text-center justify-content-center align-items-center">
                    <label>{{ day }}</label>
                  </div>
                  <div class="col-md-3">
                    <base-input type="time" label="Başlangıç Saati"
                      v-model="config.mailSendTimeRange.value[index.toString()].startTime">
                    </base-input>
                  </div>
                  <div class="col-md-3">
                    <base-input type="time" label="Bitiş Saati"
                      v-model="config.mailSendTimeRange.value[index.toString()].endTime">
                    </base-input>
                  </div>
                  <div class="col-md-1">
                    <base-checkbox type="text" label="Aktif"
                      v-model="config.mailSendTimeRange.value[index.toString()].isActive"
                      :checked="config.mailSendTimeRange.value[index.toString()].isActive"
                      @click="config.mailSendTimeRange.value[index.toString()].isActive = !config.mailSendTimeRange.value[index.toString()].isActive">
                    </base-checkbox>
                  </div>
                  <div class="col-md-2">
                    <badge class="badge badge-secondary m-1 p-2">Günlük Mail Sayısı: {{ calculateMaxMailDaily(index) }}
                    </badge>
                  </div>
                </div>

                <div class="row mt-3 float-right">
                  <div class="col-md-12 text-center">
                    <button type="submit" class="btn btn-primary btn-fill font-weight-bold"
                      @click.prevent="saveMailSettingsConfig">
                      Kaydet
                    </button>
                  </div>
                </div>


              </card>



            </template>
          </card>
        </div>

      </div>


      <!-- Mail Templates Edit Form -->
      <div class="row" v-show="activeTab === 'mailTemplates'">
        <div class="col-12">
          <card class="strpied-tabled-with-hover" body-classes="table-full-width table-responsive">
            <template slot="header">
              <h4 class="card-title m-1">Mail Tema Ayarları</h4>
              <p class="card-category m-1">Mail temalarını düzenleyin. </p>

              <div class="row">
                <div class="col-md-12">
                  <div class="row mt-3">
                    <div class="col-md-4">
                      <label>Mail Tema Seçimi</label>
                    </div>
                    <div class="col-md-5">
                      <select class="form-control" v-model="config.mailTemplate.value">
                        <option v-for="(zone, index) in Object.entries(config.mailTemplateSelections.value)" :key="index"
                          :value="zone[0]">
                          {{ zone[1] }}
                        </option>
                      </select>
                    </div>
                  </div>
                </div>
              </div>


              <div class="row m-3 float-right">
                <div class="col-md-12 text-center">
                  <button type="submit" class="btn btn-primary btn-fill font-weight-bold"
                    @click.prevent="saveMailSettingsConfig">
                    Kaydet
                  </button>
                </div>
              </div>

            </template>
          </card>
        </div>

      </div>
    </div>
  </div>
</template>
<script>
import Card from 'src/components/Cards/Card.vue'
import CollectionService from "../services/collection.service.js";

export default {
  components: {
    Card
  },
  data() {
    return {
      id: null,
      config: {},
      currencies: [{
        _id: "EUR",
        name: "Euro"
      }, {
        _id: "USD",
        name: "Dolar"
      }, {
        _id: "TRY",
        name: "Türk Lirası"
      }
      ],
      statusMap: [
        {
          _id: "active",
          name: "Listede"
        },
        {
          _id: "inactive",
          name: "Pasif"
        },
        {
          _id: "sold",
          name: "Satıldı"
        },
        {
          _id: "pending",
          name: "Beklemede"
        },
        {
          _id: "rented",
          name: "Kiralandı"
        },
        {
          _id: "maintenance",
          name: "Tamirde"
        },
        {
          _id: "other",
          name: "Diğer"
        }
      ],
      activeTab: 'generalSettings'
    }
  },
  mounted() {
    this.getConfig();
  },
  methods: {
    getConfig() {
      CollectionService.getCollection('config', null).then((res) => {
        const config = res.config.reduce((acc, curr) => {
          try {
            acc[curr.key] = { value: JSON.parse(curr.value), isLocked: curr.isLocked };
            return acc;
          } catch (error) {
            acc[curr.key] = { value: curr.value, isLocked: curr.isLocked };
            return acc;
          }

        }, {});
        this.config = config;

        // Reorder days to make Monday the first day
        const reorderedDays = Object.values(this.config.mailSendTimeRange.value);
        const sunday = reorderedDays.shift(); // Remove Sunday from start
        reorderedDays.push(sunday); // Add Sunday to end
        this.config.mailSendTimeRange.value = reorderedDays;

      })
    },
    notifyVue(verticalAlign, horizontalAlign, type, message) {
      this.$notifications.notify(
        {
          message: JSON.stringify(message),
          icon: '',
          horizontalAlign: horizontalAlign,
          verticalAlign: verticalAlign,
          type
        })
    },
    calculateMaxMailWeekly() {

      let totalMinutes = 0;
      Object.values(this.config.mailSendTimeRange.value).forEach((item) => {
        if (item.isActive) {
          const startHours = item.startTime.split(":")[0];
          const startMinutes = item.startTime.split(":")[1];

          const endHours = item.endTime.split(":")[0];
          const endMinutes = item.endTime.split(":")[1];
          totalMinutes += (endHours - startHours) * 60 + (endMinutes - startMinutes);
        }
      });
      return this.config.perMinutesSendMail.value * totalMinutes;
    },
    calculateMaxMailDaily(index) {

      const day = this.config.mailSendTimeRange.value[index];

      if (!day.isActive) {
        return 0;
      }

      const startHours = day.startTime.split(":")[0];
      const startMinutes = day.startTime.split(":")[1];

      const endHours = day.endTime.split(":")[0];
      const endMinutes = day.endTime.split(":")[1];

      const totalMinutes = (endHours - startHours) * 60 + (endMinutes - startMinutes);

      return this.config.perMinutesSendMail.value * totalMinutes;

    },
    saveMailSettingsConfig() {
      const mailConfigPayload = [{
        key: 'isMailSendRunning',
        value: this.config.isMailSendRunning.value,
        isLocked: false
      }, {
        key: 'perMinutesSendMail',
        value: this.config.perMinutesSendMail.value,
        isLocked: false
      }, {
        key: 'systemTimeZone',
        value: this.config.systemTimeZone.value,
        isLocked: false
      }]

      // Reorder days to make Sunday the first day
      const reorderedDays = Object.values(this.config.mailSendTimeRange.value);
      const sunday = reorderedDays.pop(); // Remove Sunday from end
      reorderedDays.unshift(sunday); // Add Sunday to start

      mailConfigPayload.push({
        key: 'mailSendTimeRange',
        value: reorderedDays,
        isLocked: false
      })



      CollectionService.postWidthAuth('config', mailConfigPayload).then((res) => {
        this.notifyVue('top', 'right', 'success', 'Mail gönderim ayarları başarıyla güncellendi.');
      }).catch((err) => {
        this.notifyVue('top', 'right', 'danger', 'Mail gönderim ayarları güncellenirken bir hata oluştu.');
      })
    },
    saveGeneralSettingsConfig() {
      const generalConfigPayload = [{
        key: 'companyName',
        value: this.config.companyName.value,
        isLocked: false
      }, {
        key: 'companyIdentifier',
        value: this.config.companyIdentifier.value,
        isLocked: false
      }, {
        key: 'companyWebsite',
        value: this.config.companyWebsite.value,
        isLocked: false
      }, {
        key: 'companyContactPerson',
        value: this.config.companyContactPerson.value,
        isLocked: false
      }, {
        key: 'companyPhone',
        value: this.config.companyPhone.value,
        isLocked: false
      }, {
        key: 'companyEmail',
        value: this.config.companyEmail.value,
        isLocked: false
      }, {
        key: 'companyAddress',
        value: this.config.companyAddress.value,
        isLocked: false
      }, {
        key: 'portfolioPlatform',
        value: this.config.portfolioPlatform.value,
        isLocked: false
      }, {
        key: 'portfolioPlatformTarget',
        value: this.config.portfolioPlatformTarget.value,
        isLocked: false
      }
      ]

      CollectionService.postWidthAuth('config', generalConfigPayload).then((res) => {
        this.notifyVue('top', 'right', 'success', 'Genel sistem ayarları başarıyla güncellendi.');
      }).catch((err) => {
        this.notifyVue('top', 'right', 'danger', 'Genel sistem ayarları güncellenirken bir hata oluştu.');
      })
    }
  }
}
</script>
<style>
.nav-tabs .nav-link {
  cursor: pointer;
}
</style>